module.exports = __webpack_public_path__ + "images/default-skin-3097be4dfb480c2439f08d0d835a40b9.png";